import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { FieldError } from 'components/misc'
import fieldId from 'constants/layout/fieldId'
import styles from './input.styl'
import BaseInput from './BaseInput'

export default class Input extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    normalize: PropTypes.func,
    normalizeOnBlur: PropTypes.func,
    intlKey: PropTypes.string,
    onInputChange: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    step: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    maxLength: PropTypes.number,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    autoComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    normalize: null,
    validate: () => {}
  }

  handleChange = (e, field) => {
    if (this.props.onInputChange) {
      this.props.onInputChange(e.target.value)
    }
    field.input.onChange(e.target.value)
  }

  handleOnBlur = (e, field) => {
    if (this.props.normalizeOnBlur) {
      this.props.normalizeOnBlur(field)
    }
    field.input.onBlur()
  }

  renderField = field => {
    const {
      autoComplete,
      readOnly,
      step,
      min,
      max,
      maxLength,
      type,
      disabled,
    } = this.props
    const { meta, input } = field

    const isError = meta.touched && meta.error
    const classNames = ['form-control']
    const wrapperClassnames = ['form-control-wrapper']

    isError && classNames.push('error')
    disabled && wrapperClassnames.push(styles.disabled)

    let numberParams = {}

    if (type === 'number') {
      numberParams = {
        step,
        min,
        max
      }
    }

    return (
      <div className={wrapperClassnames.join(' ')}>
        <BaseInput
          formControlProps={{ className: classNames.join(' ') }}
          {...input}
          {...numberParams}
          maxLength={maxLength}
          autoComplete={autoComplete}
          type={type || 'text'}
          disabled={readOnly || disabled}
          onBlur={e => this.handleOnBlur(e, field)}
          onChange={e => this.handleChange(e, field)}
        />
        <FieldError toShow={isError} message={meta.error} />
      </div>
    )
  }

  render() {
    const { label, name, intlKey, disabled, optional, type } = this.props
    const classNames = ['control-label']
    const hidden = type === 'hidden'
    const groupClass = [!hidden ? 'form-group' : '']

    disabled && classNames.push('control-label-disabled')

    return (
      <div className={groupClass.join(' ')} id={`${fieldId}.${name}`}>
        <label htmlFor={name} className={classNames.join(' ')}>
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
          {optional &&
            <span>
              {' '}
              (
              <FormattedMessage id="label.optional" defaultMessage="optional" />
              )
            </span>}
        </label>
        <Field
          {...this.props}
          id={name}
          name={name}
          component={this.renderField}
          normalize={this.props.normalize}
          validate={this.props.validate}
        />
      </div>
    )
  }
}
